import { Card, Typography, WithStyles } from "@material-ui/core";
import { styles } from "./ProductCard.styles";
import * as React from "react";
import { withStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import { BUYING_OPTION_OTP } from "./ProductHelper";

export interface ProductCardProps extends WithStyles<typeof styles> {
    identifier: string,
    title: string;
    logos?: any[];
    isA7?: boolean;
    isSampleData?: boolean;
    productOptions?: any[];
    prices?: any;
    onClick?: any;
}

function getBusinessDaysString(minimalDays) {
    return `business ${minimalDays > 1 ? "days" : "day"}`;
}

const ProductCardPure: React.FunctionComponent<ProductCardProps> = ({
    classes,
    identifier,
    title,
    logos,
    isA7,
    isSampleData,
    productOptions,
    prices,
    onClick
}) => {
    const history = useHistory();

    const navigateToDetailView = () => {
        if (isA7) {
            history.push(`/a7product/details/${identifier}`);
        } else if (isSampleData) {
            history.push(`/sample-data/details/${identifier}`);
        } else {
            history.push(`/product/details/${identifier}`);
        }
    };

    return <Card className={classes.productCard} onClick={onClick ?? navigateToDetailView}>

        <div className={classes.productLogo}>
            {logos?.map(logo => <img key={logo.name} src={logo.path} alt={logo.name} />)}
        </div>
        <Typography variant="h3">{title}</Typography>
        <ul>
            {productOptions?.map(o =>
                <li key={o} className={classes.productBuyingOption}>{BUYING_OPTION_OTP === o ? "One-off order" : "Subscription"}</li>
            )}
            {productOptions === undefined && !isA7 && !isSampleData
                ? <li key="subcategory" className={classes.productBuyingOption}>{"Subcategory"}</li>
                : null
            }
        </ul>
        {prices && prices > 0 ? <div className={classes.price}><Typography variant="caption">from
            €{prices.dailyPrice}/{"day"} {prices.minimalDays ? `(minimum order size ${prices.minimalDays} ${getBusinessDaysString(prices.minimalDays)})` : ""}</Typography>
        </div> : null}

    </Card>;
};

export const ProductCard = withStyles(styles)(ProductCardPure);